import React from 'react';
import { connect, useDispatch } from 'react-redux';
import SliderWrapper from 'jd-library/SliderWrapper';
import historyHandler from 'jd-library/historyHandler';
import { toggleBarcodeScannerSecondary } from '../../../actions/barcodeScanner';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Scanner from './Scanner';

const BarcodeScanner = props => {
	const dispatch = useDispatch();
	const history = useHistory();
	const onDetected = useCallback(
		result => {
			if(props.showScannerSecond){
				historyHandler.closeCurrent();
			}
			setTimeout(() => {
				props.onDetectedCB && props.onDetectedCB(result, dispatch, {
					history
				});
			}, 300)
		},
		[props.onDetectedCB]
	);
	const onFailed = useCallback((obj) => {
		if(props.showScannerSecond){
			historyHandler.closeCurrent();
		}
		if(!obj || obj.status != 1){
			setTimeout(() => {
				props.onFailedCB && props.onFailedCB(dispatch);
			}, 300)
		}
	}, [props.onFailedCB]);
	return (
		<SliderWrapper
			onHidden={() => {
				props.toggleBarcodeScannerSecondary({
					showScannerSecond: false
				});
			}}
		>
			<Scanner onDetected={onDetected} onFailed={(obj)=>onFailed(obj)} />
		</SliderWrapper>
	);
};

const mapStateToProps = ({ barcodeScanner }, props) => ({
	...props,
	...barcodeScanner
});

export default connect(mapStateToProps, {
	toggleBarcodeScannerSecondary
})(BarcodeScanner);
